import { type SettingsHierarchyNode } from './types';

/*
 * Функция для нахождения узла настроек по массиву слагов и пути до настройки
 * @param setting - иерархия настроек
 * @param pathArray - массив слагов пути до настройки
 * @param leafPath - путь до настройки
 */
export function findSettingsChild(
    setting: SettingsHierarchyNode,
    pathArray: Array<string>,
    leafPath: string
): SettingsHierarchyNode | undefined {
    let child: SettingsHierarchyNode | undefined;
    let childPath: SettingsHierarchyNode | undefined;

    setting?.children.forEach(settingChild => {
        const slug = settingChild.setting.path.split('/').at(-1);

        if (slug === pathArray[0]) {
            childPath = settingChild;
        }

        if (settingChild.setting.path === `${leafPath}`) {
            child = settingChild;
        }
    });

    if ((child?.setting.path || childPath?.setting.path) === (leafPath.startsWith('/') ? leafPath : `/${leafPath}`)) {
        return child || childPath;
    }

    if (child) {
        return findSettingsChild(child, pathArray.slice(1), leafPath);
    }

    if (childPath) {
        return findSettingsChild(childPath, pathArray.slice(1), leafPath);
    }

    return undefined;
}
